import React from 'react';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import API from '../../configAPI';
import PulseLoader from 'react-spinners/PulseLoader';
import {Link} from 'react-router-dom';
import CONFIG from '../../config';
import Moment from 'react-moment';
import 'moment-timezone';
class PostList extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            videos : {
                data: [],
                current_page: 1,
                total: 0,
                last_page: 1
            },
            loading: true
        }
    }
    componentDidMount(){
        this.getVideos();
    }
    componentDidUpdate(prevProps){
        if(this.props.match.params.video !== prevProps.match.params.video){
            this.getVideos();
        }
    }
    getVideos =()=>{
        API.PRODUCTS(`videoprov/${this.props.match.params.video}?page=${this.state.videos.current_page}`)
        .then(resp =>{
            this.setState({
                videos : resp.data,
                loading : false,

            });
             console.log(resp.data);
        })
        .catch(err =>{
            console.log(err);
        });
    }
    onChanhePage = async(page) =>{
        await this.setState({
            videos : {
                ...this.state.videos,
                current_page : page
            },
            loading : !this.state.loading
        });

        this.getVideos();
    }
    render(){
        return (
            <div className="container-fluid mt-2 mb-3">
                <div className="col-12">
                    <PulseLoader
                        css={CONFIG.spinner_css}
                        size={CONFIG.spinner_size}
                        margin={CONFIG.spinner_margin}
                        color={CONFIG.spinner_color}
                        loading={this.state.loading}
                    />

                    <div className="row">
                        <section className="col-12">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                <li className="breadcrumb-item" aria-current="page"><span className="black">Todos los videos</span></li>            
                                </ol>
                            </nav>
                        </section>
                    </div>
                    <div className="mt-3 d-flex justify-content-center">
                        {this.state.videos.last_page > 1 &&
                            <Pagination 
                                onChange={this.onChanhePage}
                                current={this.state.videos.current_page}
                                total={this.state.videos.total}
                                showTitle={false}
                                defaultPageSize={this.state.videos.to}
                            />
                        }
                    </div>
                    {this.state.videos.total > 0 ? 
                    <div className="row">
                        {this.state.videos.data.map((vid,index) =>(
                            <section className="col-xs-12 col-md-4 mt-1 mb-1" key={index}>
                                <div className="fila relativo">
                                    <Link to={`/video/${vid.slug}`}> 
                                        { <img src={`https://panel.construproductos.com/images/products/${vid.url_img}`} className="img-fluid" alt="{vid.titulo}"/> 
                                          /*  <img src={`http://adminarq.expodeco.pe/images/products/${vid.url_img}`} className="img-fluid" alt="{vid.titulo}"/>*/
                                        }
                                        <div className="noticialink d-flex align-items-center p-2">
                                            <div className="fila">
                                            <section className="col-12 text-center">
                                                <h1 className="noticiatitulo"><i class="far fa-play-circle"> ver video</i></h1>
                                            </section>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="mt-3">
                                    <h6><strong>{vid.titulo}</strong></h6>
                                    <p className="minitext">Publicado el <Moment format={'DD/MM/YYYY'}>{vid.created_at}</Moment></p>
                                    <p>{vid.info.substr(0,70)} ...</p>
                                </div>
                            
                            </section>
                        ))}
                    </div>
                    : 
                    <div>
                    <h4 class="text-center">"Por el momento no hay videos, busque más tarde"</h4>
                    <p class="text-center"><a href="/videos"><i class="far fa-play-circle"></i>  Ver otros videos</a></p>
                    <br></br><br></br><br></br><br></br><br></br><br></br><br></br>

                    </div>


                    }


                    <div className="mt-3 d-flex justify-content-center">
                        {this.state.videos.last_page > 1 &&
                            <Pagination 
                                onChange={this.onChanhePage}
                                current={this.state.videos.current_page}
                                total={this.state.videos.total}
                                showTitle={false}
                                defaultPageSize={this.state.videos.to}
                            />
                        }
                    </div>
                </div>

            </div>
        )
    }
}

export default PostList;